import styled from "styled-components";

import { useUpdateUrlParams } from "hooks/useUpdateUrlParams";
import { salesDashboardInnerMembersTabOptions } from "constants/businessDashboard";
import type { MemberTabType } from "types/BusinessDashboard";

const Container = styled.div`
  width: 100%;
  background-color: transparent;
  margin-bottom: 12px;
  padding: 0 16px;
`;

const TabNavWrapper = styled.nav`
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: #e9eefb;
  border-radius: 10px;
  padding: 4px;
  height: 36px;
  position: relative;
  box-sizing: border-box;
`;

const TabButton = styled.button<{ active: boolean }>`
  flex: 1 1 0%;
  height: 28px;
  border: none;
  outline: none;
  border-radius: 8px;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.2px;
  font-weight: ${({ active }) => (active ? 700 : 500)};
  color: ${({ active }) => (active ? "#4C525D" : "#4C5874")};
  background: ${({ active }) => (active ? "#fff" : "transparent")};
  box-shadow: ${({ active }) => (active ? "0px 1px 4px 0px #0000001A" : "")};
  transition:
    background 0.25s,
    color 0.25s,
    font-weight 0.25s;
  cursor: pointer;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export function DashboardInnerMembersTabNavigation() {
  const { searchParams, updateUrlParams } = useUpdateUrlParams();
  const currentInnerTab = (searchParams.get("innerMembersTab") ??
    "period") as MemberTabType;

  const handleTab = (innerTab: MemberTabType) => {
    updateUrlParams({
      innerMembersTab: innerTab,
    });
  };

  return (
    <Container>
      <TabNavWrapper>
        {salesDashboardInnerMembersTabOptions.map((tab) => (
          <TabButton
            key={tab.id}
            active={currentInnerTab === tab.id}
            onClick={() => handleTab(tab.id)}
            type="button"
          >
            {tab.label}
          </TabButton>
        ))}
      </TabNavWrapper>
    </Container>
  );
}
